"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderedListApp = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const OrderedListContext_1 = require("./OrderedListContext");
const OrderedListMenu_1 = require("./OrderedListMenu");
function OrderedListApp(props) {
    const { orderedStyle: defaultOrderedStyle, orderedRegex: defaultOrderedRegex = '', orderedNumberingStyle: defaultOrderedNumberingStyle = 'numbers', orderedStart: defaultOrderedStart = 1, orderedWidth: defaultOrderedWidth, isContinueFromPrevious: defaultIsContinueFromPrevious, isAdvancedOrderedStyleEnable: defaultIsAdvancedOrderedStyleEnable = false, listStyles: defaultListStyles, setOrderedStyle: setDefaultOrderedStyle, setOrderedRegex: setDefaultOrderedRegex, setOrderedNumberingStyle: setDefaultOrderedNumberingStyle, setOrderedStart: setDefaultOrderedStart, setOrderedWidth: setDefaultOrderedWidth, setContinueFromPrevious: setDefaultContinueFromPrevious, toggleAdvancedOrderedStyle: toggleDefaultAdvancedOrderedStyle, } = props;
    const [activeTabIndex, setActiveTabIndex] = (0, react_1.useState)(0);
    const [orderedStyle, setOrderedStyleState] = (0, react_1.useState)(defaultOrderedStyle);
    const [orderedRegex, setOrderedRegexState] = (0, react_1.useState)(defaultOrderedRegex);
    const [orderedNumberingStyle, setOrderedNumberingStyleState] = (0, react_1.useState)(defaultOrderedNumberingStyle);
    const [orderedStart, setOrderedStartState] = (0, react_1.useState)(defaultOrderedStart);
    const [orderedWidth, setOrderedWidthState] = (0, react_1.useState)(defaultOrderedWidth);
    const [isContinueFromPrevious, setContinueFromPreviousState] = (0, react_1.useState)(defaultIsContinueFromPrevious);
    const [isAdvancedOrderedStyleEnable, toggleAdvancedOrderedStyleState] = (0, react_1.useState)(defaultIsAdvancedOrderedStyleEnable);
    const [listStyles, setListStyles] = (0, react_1.useState)(defaultListStyles);
    const setOrderedStyle = (listId) => {
        setOrderedStyleState(listId);
        setDefaultOrderedStyle === null || setDefaultOrderedStyle === void 0 ? void 0 : setDefaultOrderedStyle(listId);
    };
    const setOrderedRegex = (pattern) => {
        setOrderedRegexState(pattern);
        setDefaultOrderedRegex === null || setDefaultOrderedRegex === void 0 ? void 0 : setDefaultOrderedRegex(pattern);
    };
    const setOrderedNumberingStyle = (numberingStyle) => {
        setOrderedNumberingStyleState(numberingStyle);
        setDefaultOrderedNumberingStyle === null || setDefaultOrderedNumberingStyle === void 0 ? void 0 : setDefaultOrderedNumberingStyle(numberingStyle);
    };
    const setOrderedStart = (orderedStart) => {
        setOrderedStartState(orderedStart);
        setDefaultOrderedStart === null || setDefaultOrderedStart === void 0 ? void 0 : setDefaultOrderedStart(orderedStart);
    };
    const setOrderedWidth = (orderedWidth) => {
        setOrderedWidthState(orderedWidth);
        setDefaultOrderedWidth === null || setDefaultOrderedWidth === void 0 ? void 0 : setDefaultOrderedWidth(orderedWidth);
    };
    const setContinueFromPrevious = (isContinueFromPrevious) => {
        setContinueFromPreviousState(isContinueFromPrevious);
        setDefaultContinueFromPrevious === null || setDefaultContinueFromPrevious === void 0 ? void 0 : setDefaultContinueFromPrevious(isContinueFromPrevious);
    };
    const toggleAdvancedOrderedStyle = (enable) => {
        toggleAdvancedOrderedStyleState(enable);
        toggleDefaultAdvancedOrderedStyle === null || toggleDefaultAdvancedOrderedStyle === void 0 ? void 0 : toggleDefaultAdvancedOrderedStyle(enable);
    };
    (0, react_1.useEffect)(() => {
        setOrderedStyleState(defaultOrderedStyle);
    }, [defaultOrderedStyle]);
    (0, react_1.useEffect)(() => {
        setOrderedRegexState(defaultOrderedRegex);
    }, [defaultOrderedRegex]);
    (0, react_1.useEffect)(() => {
        setOrderedNumberingStyleState(defaultOrderedNumberingStyle);
    }, [defaultOrderedNumberingStyle]);
    (0, react_1.useEffect)(() => {
        setOrderedStartState(defaultOrderedStart);
    }, [defaultOrderedStart]);
    (0, react_1.useEffect)(() => {
        setOrderedWidthState(defaultOrderedWidth);
    }, [defaultOrderedWidth]);
    (0, react_1.useEffect)(() => {
        setContinueFromPreviousState(defaultIsContinueFromPrevious);
    }, [defaultIsContinueFromPrevious]);
    (0, react_1.useEffect)(() => {
        toggleAdvancedOrderedStyleState(defaultIsAdvancedOrderedStyleEnable);
    }, [defaultIsAdvancedOrderedStyleEnable]);
    (0, react_1.useEffect)(() => {
        setListStyles(defaultListStyles);
    }, [defaultListStyles]);
    const onActiveTabChange = (index) => {
        setActiveTabIndex(index);
    };
    return ((0, jsx_runtime_1.jsx)(OrderedListContext_1.OrderedListContext.Provider, { value: Object.assign(Object.assign({}, props), { orderedStyle,
            orderedRegex,
            orderedNumberingStyle,
            orderedStart,
            orderedWidth,
            listStyles,
            isContinueFromPrevious,
            isAdvancedOrderedStyleEnable,
            setOrderedStyle,
            setOrderedRegex,
            setOrderedNumberingStyle,
            setOrderedStart,
            setOrderedWidth,
            setContinueFromPrevious,
            toggleAdvancedOrderedStyle,
            activeTabIndex,
            onActiveTabChange }), children: (0, jsx_runtime_1.jsx)(OrderedListMenu_1.OrderedListMenu, {}) }));
}
exports.OrderedListApp = OrderedListApp;
//# sourceMappingURL=App.js.map